import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  key: 0,
  class: "flex justify-end mt-6"
};
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { downloadFile } from '@/utils/file-helpers';
import SpotItem from '@/views/components/SpotItem.vue';
import PreviewImages from '@/components/PreviewImages.vue';
import { AI_TRACK_PREFILL_KEY } from '@/views/home/pages/ai-track/api';
import DetailDialog from './DetailDialog.vue';
import { getMedia, GetShopNewsPublishResult } from '../../api/media';

// 定义 props

export default {
  __name: 'MediaTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    approvalOptions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isSummary: {
      type: Boolean,
      default: false
    },
    // 是否显示「添加追踪」按钮（暂仅内贸发布管理使用）
    enableTrack: {
      type: Boolean,
      default: false
    }
  },
  emits: ['download', 'view', 'page-change', 'size-change'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const router = useRouter();

    // 定义 emits
    const emit = __emit;

    // 响应式数据
    const downloading = ref(false);
    const detailDialogRef = ref(null);
    const previewImagesRef = ref(null);

    // 下载
    const handleDownload = async row => {
      if (downloading.value) return;
      downloading.value = true;
      try {
        await downloadFile(row.FileUrl, row.Title || 'download');
        emit('download', row);
      } catch (error) {
        // 文件下载失败处理
      } finally {
        downloading.value = false;
      }
    };

    // 查看
    const handleView = row => {
      detailDialogRef.value.openDialog(row);
    };

    // 图文判定：图文行带 exInfo.images 数组，视频行无此字段
    const isImageSet = row => Array.isArray(row.exInfo?.images);

    // 查看图片：图文使用 exInfo.images 多图预览
    const handleViewImages = row => {
      const exInfo = row.exInfo || {};
      let images = exInfo.images || [];
      if (!images.length && exInfo.cover) {
        images = [exInfo.cover];
      }
      if (!images.length) {
        ElMessage.warning('暂无图片数据');
        return;
      }
      previewImagesRef.value.open(images);
    };

    // 重新发布：被驳回的数据跳回视频/图文发布页，路由携带 mediaID 由页面拉取详情回填
    const handleRepublish = row => {
      router.push({
        path: '/home/media/video',
        query: {
          mediaID: row.MediaID
        }
      });
    };

    // 联盟新闻发布结果链接（与 DetailDialog.getPublishUrl 一致）
    const getPublishUrl = (item, newsID) => {
      if (item.SiteName === '宝发网' && newsID) {
        return `${item.URL}showinfo-${newsID}`;
      }
      return item.URL;
    };

    // 添加追踪：获取该条已发布的全部文章链接（取链方式与「查看」一致），
    // 携带链接跳回 AI 引用追踪新增页并自动填入文本域
    const trackLoading = ref(false);
    const handleAddTrack = async row => {
      if (trackLoading.value) return;
      trackLoading.value = true;
      try {
        let urls = [];
        if (props.type === '4') {
          // 联盟新闻：发布结果明细
          const res = await GetShopNewsPublishResult({
            newsID: row.NewsID
          });
          const list = res.data?.detail || [];
          urls = list.map(item => getPublishUrl(item, row.NewsID)).filter(Boolean);
        } else {
          // 其他媒体：详情中已发布(AuditStatus==2)的结果链接
          const e = await getMedia({
            mediaID: row.MediaID
          });
          const detail = e.data?.detail || [];
          urls = detail.filter(d => d.AuditStatus === 2).map(d => d.ResultUrl).filter(Boolean);
        }
        if (!urls.length) {
          ElMessage.warning('未获取到已发布的文章链接');
          return;
        }
        // 链接较多/较长，payload 放 sessionStorage（关闭标签自动清理）；
        // 用 query 标记作为可刷新的信号
        sessionStorage.setItem(AI_TRACK_PREFILL_KEY, JSON.stringify(urls));
        router.push({
          path: '/home/aiTrack',
          query: {
            from: 'track'
          }
        });
      } catch (e) {
        // 错误已由请求拦截器统一处理
      } finally {
        trackLoading.value = false;
      }
    };

    // 分页处理
    const handlePageChange = page => {
      emit('page-change', page);
    };
    const handleSizeChange = size => {
      emit('size-change', size);
    };

    // 操作列宽度：图文行出现「查看图片」、被驳回行出现「重新发布」时需要更宽
    const actionColWidth = computed(() => {
      if (props.enableTrack) return 230;
      if (props.type === '9') return 200;
      return 130;
    });
    const getStatusName = status => {
      const option = props.approvalOptions.find(opt => opt.value === status);
      return option ? option.label : '--';
    };

    // 暴露方法给父组件
    __expose({
      handleDownload,
      handleView
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["media-table", {
          isSummary: props.isSummary
        }])
      }, [_createVNode(_component_el_table, {
        data: __props.tableData,
        loading: __props.loading,
        height: props.isSummary ? 'calc(100vh - 250px)' : '320',
        class: "w-full"
      }, {
        default: _withCtx(() => [props.isSummary && props.type != '9' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          prop: "geoTaskName",
          label: "发布任务",
          "show-overflow-tooltip": "",
          "min-width": "300"
        })) : _createCommentVNode("", true), props.isSummary && props.type != '9' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 1,
          prop: "geokeyword",
          label: "AI提示词",
          "show-overflow-tooltip": "",
          "min-width": "300"
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          prop: "Title",
          label: props.type == '9' ? '视频标题' : '新闻标题',
          "show-overflow-tooltip": "",
          "min-width": "300"
        }, null, 8, ["label"]), props.type == '9' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 2,
          label: "视频封面",
          width: "120",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [row.exInfo && row.exInfo.cover ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            src: row.exInfo.cover,
            "preview-src-list": [row.exInfo.cover],
            "preview-teleported": "",
            fit: "cover",
            class: "cover-img"
          }, null, 8, ["src", "preview-src-list"])) : (_openBlock(), _createElementBlock("span", _hoisted_1, "--"))]),
          _: 1
        })) : _createCommentVNode("", true), props.type == '9' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 3,
          label: "关键词",
          "show-overflow-tooltip": "",
          "min-width": "160"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.exInfo && row.exInfo.keyword || '--'), 1)]),
          _: 1
        })) : _createCommentVNode("", true), props.type == '9' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 4,
          label: "描述",
          "show-overflow-tooltip": "",
          "min-width": "160"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.exInfo && row.exInfo.desc || '--'), 1)]),
          _: 1
        })) : _createCommentVNode("", true), props.type == '9' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 5,
          label: "备注",
          "show-overflow-tooltip": "",
          "min-width": "160"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.exInfo && row.exInfo.remark || '--'), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          prop: "AuditStatus",
          label: "状态",
          width: "106",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [!props.isSummary ? (_openBlock(), _createBlock(SpotItem, {
            key: 0,
            list: __props.approvalOptions,
            value: row.AuditStatus
          }, null, 8, ["list", "value"])) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["inline-flex items-center gap-1 text-xs h-[20px]", 'tag_' + row.AuditStatus])
          }, _toDisplayString(getStatusName(row.AuditStatus)), 3))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "AddDate",
          label: "提交时间",
          "min-width": "190",
          sortable: ""
        }), _createVNode(_component_el_table_column, {
          prop: "ScheduledPubTime",
          label: "定时发布时间",
          "min-width": "190"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.ScheduledPubTime || '立即发布'), 1)]),
          _: 1
        }), props.type != '9' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 6,
          prop: "useCount",
          label: "消耗权益",
          "min-width": "120",
          align: "center"
        })) : _createCommentVNode("", true), props.type == '9' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 7,
          label: "消耗权益",
          "min-width": "120",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.Expenses ?? '--'), 1)]),
          _: 1
        })) : _createCommentVNode("", true), props.type != '4' ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 8,
          prop: "Media",
          label: "发布平台",
          "show-overflow-tooltip": "",
          "min-width": "190"
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: actionColWidth.value
        }, {
          default: _withCtx(({
            row
          }) => [props.type != '4' && !(props.type == '9' && isImageSet(row)) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            link: "",
            onClick: $event => handleDownload(row),
            disabled: downloading.value,
            class: "mr-3 font-normal"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 下载 ", -1)]))]),
            _: 1
          }, 8, ["onClick", "disabled"])) : _createCommentVNode("", true), props.type == '9' && isImageSet(row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            link: "",
            onClick: $event => handleViewImages(row),
            class: "mr-3 font-normal"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 查看图片 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), props.type == '9' && row.AuditStatus === -1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            type: "primary",
            link: "",
            onClick: $event => handleRepublish(row),
            class: "mr-3 font-normal"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 重新发布 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            type: "primary",
            class: "font-normal",
            link: "",
            onClick: $event => handleView(row)
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 查看 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }, 8, ["width"])]),
        _: 1
      }, 8, ["data", "loading", "height"]), __props.total > __props.pageSize || props.isSummary ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_pagination, {
        "current-page": __props.currentPage,
        "page-size": __props.pageSize,
        "page-sizes": [10, 20, 50, 100],
        total: __props.total,
        layout: "total, prev, pager, next, sizes, jumper",
        onSizeChange: handleSizeChange,
        onCurrentChange: handlePageChange,
        class: "pagination"
      }, null, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true), _createVNode(DetailDialog, {
        ref_key: "detailDialogRef",
        ref: detailDialogRef,
        type: props.type
      }, null, 8, ["type"]), _createVNode(PreviewImages, {
        ref_key: "previewImagesRef",
        ref: previewImagesRef
      }, null, 512)], 2);
    };
  }
};